import React from "react";
import PropTypes from "prop-types";
import { Content, Ripple } from "./style";
import { values } from "../../../theme/constants";

const RippleButton = (props) => {
    const [coords, setCoords] = React.useState({ x: -1, y: -1 });
    const [isRippling, setIsRippling] = React.useState(false);

    if (!props.component) return null;

    const Component = props.component;
    React.useEffect(() => {
        if (coords.x !== -1 && coords.y !== -1) {
            setIsRippling(true);
            setTimeout(
                () => setIsRippling(false),
                parseInt(values.RIPPLE_TRANSITION_DURATION) / 3
            );
        } else setIsRippling(false);
    }, [coords]);

    React.useEffect(() => {
        if (!isRippling) setCoords({ x: -1, y: -1 });
    }, [isRippling]);

    return (
        <Component
            {...props}
            style={{ ...(props.style ? props.style : {}), overflow: "hidden" }}
            onClick={(e) => {
                const rect = e.target.getBoundingClientRect();
                setCoords({
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top,
                });
                props.onClick && props.onClick(e);
            }}
        >
            {isRippling ? (
                <Ripple
                    style={{
                        left: coords.x,
                        top: coords.y,
                    }}
                />
            ) : (
                ""
            )}
            <Content appearance={props.appearance}>{props.children}</Content>
        </Component>
    );
};

RippleButton.defaultProps = {
    appearance: "default",
};

RippleButton.propTypes = {
    children: PropTypes.any,
    component: PropTypes.any,
    appearance: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.any,
};

export default RippleButton;
